import React from 'react';

export const Seaweed = ({ left, height, delay }) => {
  const style = {
    left: `${left}%`,
  };

  const bladeStyle = {
    height: `${height}px`,
    animationDelay: `${delay}s`,
  };

  return (
    <div className="seaweed" style={style}>
      <div className="seaweed-blade" style={bladeStyle} />
    </div>
  );
};
